import { IEntertainmentEvent } from '@shared/shared/interfaces/entertainment-event.interfaces';
import * as entertainmentEventActions from '../actions/entertainment-event.actions';

export interface EntertainmentEventState extends IEntertainmentEvent {
  loaded: boolean;
  loading: boolean;
}

export const initialState: EntertainmentEventState = {
  id: 0,
  artists: [],
  category: '',
  city_names: [],
  currency: '',
  description: '',
  first_date: '',
  hero_images: [],
  last_date: '',
  maximum_price: 0,
  minimum_price: 0,
  name: '',
  next_performance: '',
  number_of_performances: 0,
  number_of_venues: 0,
  object_type: '',
  review: '',
  small_images: [],
  tags: [],
  terms_and_conditions: '',
  top_tips: '',
  url: '',
  venues: [],
  loading: false,
  loaded: false,
};

export function reducer(
  state = initialState,
  action: entertainmentEventActions.EntertainmentEventAction
): EntertainmentEventState {
  switch (action.type) {
    case entertainmentEventActions.GET_ENTERTAINMENT_EVENT: {
      return {
        ...initialState,
        loading: true,
      };
    }

    case entertainmentEventActions.GET_ENTERTAINMENT_EVENT_SUCCESS: {
      return {
        ...state,
        ...action.payload,
        loading: false,
        loaded: true,
      };
    }

    case entertainmentEventActions.GET_ENTERTAINMENT_EVENT_FAIL: {
      return {
        ...state,
        loaded: false,
        loading: false,
      };
    }
    default:
      return state;
  }
}
